<script setup>
import {onMounted, ref, reactive, nextTick} from "vue";
import YTTablePagination from "@/components/YTTablePagination/YTTablePagination.vue";
import moment from "moment";
import {listTicketRedemption} from "@/api/ticket/ticket.js";
import {storeAllList} from "@/api/post/post.js";
import {userTokenStore} from "@/store/store.js";
import axios from 'axios';
/*初次加载*/
onMounted(async () => {
  await handleGetStore('init')
  await handleSearch()
})

/*搜索功能*/
// 表单数据
const formData = reactive({
  storeId: null,
  date: null,
  endDate: null,
});
// 根据表单搜索信息
const handleSearch = async (mode = 'init') => {
  if (mode === 'btnSearch') YTTablePaginationRef.value.resetPage()
  try {
    const page = {
      page: YTTablePaginationRef.value.getPage(),
      pageSize: YTTablePaginationRef.value.getPageSize()
    }
    const param = {
      storeId: formData.storeId,
      startTime: formData.date ? moment(formData.date).format("YYYY-MM-DD HH:mm:ss") : null,
      endTime: formData.endDate ? moment(formData.endDate).clone().endOf('day').format("YYYY-MM-DD HH:mm:ss") : null
    }
    console.log("param", param)
    loading.value = true
    const res = await listTicketRedemption(page, param)
    tableData.value = []
    tableData.value = res.list
    total.value = parseInt(res.total)
    loading.value = false
  } catch (e) {
    loading.value = false
  }
}
// 清空表单内容
const handleReset = () => {
  formData.storeId = null
  formData.date = null
  formData.endDate = null
  cacheStore.value = {
    name: null,
    storeId: null
  }
  handleSearch('btnSearch')
}

/*表格数据展示*/
// 翻页组件锚点
const YTTablePaginationRef = ref()
// 翻页信息：总条目数、加载状态
const total = ref(0)
const loading = ref(false)
// 表头信息
const headers = ref([
  { title: '卡券名称', key: 'goodsName', nowrap: true },
  { title: '用户ID', key: 'userId', nowrap: true },
  { title: '用户昵称', key: 'nickname', nowrap: true },
  { title: '手机号', key: 'phone', nowrap: true },
  { title: '兑换门店', key: 'storeName', nowrap: true },
  { title: '核销时间', key: 'redeemedTime', nowrap: true },
  { title: '核销人', key: 'redeemedNickname', nowrap: true },
])
// 表格数据
const tableData = ref([])
// 翻页
const handleChangePage = () => {
  handleSearch()
}
// 门店列表
const storeListArr = ref([])
// 门店总数条
const memberTotal = ref(0)
// 门店翻页锚点
const YTTablePaginationMemberRef = ref()
// 处理门店翻页
const handleChangeMemberPage = () => {
  handleGetStore()
}
// 门店列表加载状态
const storeLoading = ref(false)
// 门店下拉搜索值
const storeSelectKey = ref()
// 处理搜索条件列表：门店
const handleGetStore = async (type) => {
  await nextTick(async () => {
    try {
      if (type === 'search') {
        if (memberTotal > 0) YTTablePaginationMemberRef.value.resetPage()
      }
      let param = {
        page: type === 'init' ? 1 : YTTablePaginationMemberRef.value.getPage(),
        pageSize: type === 'init' ? 5 : YTTablePaginationMemberRef.value.getPageSize()
      }
      storeLoading.value = true
      const res = await storeAllList(param, {name: storeSelectKey.value})
      storeListArr.value = res.list
      memberTotal.value = parseInt(res.total)
      storeLoading.value = false
    } catch (e) {
      console.log(e)
      storeLoading.value = false
    }
  })
}
// 缓存选择的门店
const cacheStore = ref({
  name: null,
  storeId: null
})
// 处理选择器选择门店
const handleSelectStore = (e) => {
  formData.storeId = e
  cacheStore.value = storeListArr.value.find(i => i.storeId === e)
  console.log("formData", formData)
}

// 处理选择器开始日期选择
const handleSelectDate = (date) => {
  console.log("date", date)
  formData.date = handleDateFormat(date)
  // 校验结束日期是否小于开始日期
  if (moment(formData.date).isAfter(moment(formData.endDate))) {
    formData.endDate = null
  }
}
// 处理选择器结束日期选择
const handleSelectEndDate = (date) => {
  console.log("endDate", date)
  formData.endDate = handleDateFormat(date)
  console.log("form.endDate", formData.endDate)
}
// 处理日期格式
const handleDateFormat = (date) => {
  return moment(date).format('YYYY-MM-DD')
}

// 处理点击门店下拉列表
const handleClickSelect = (e) => {
  // 下拉展示菜单时重新请求门店列表
  if (e) {
    handleGetStore('search')
  }
}

// 处理下载卡券核销报表
const handleDownload = async () => {
  ElMessage.warning("下载中...")
  let param = "?"
  let paramArr = []
  if (formData.storeId) paramArr.push(`storeId=${formData.storeId}`)
  if (formData.date) paramArr.push(`startTime=${moment(formData.date).format("YYYY-MM-DD HH:mm:ss")}`)
  if (formData.endDate)paramArr.push(`endTime=${moment(formData.endDate).clone().endOf('day').format("YYYY-MM-DD HH:mm:ss")}`)
  param+=paramArr.join("&")
  console.log("param", param)
  await downloadFile(
      `${import.meta.env.VITE_API_URL}/admin/ticket/redemption/export${param === "?" ? "" : param}`, // 请求体数据
      `核销卡券报表-${moment().format("YYYY-MM-DD_HHmmss")}.csv` // 默认文件名
  );
}

/**
 * 自定义文件名的下载函数
 * @param {string} url - 完整接口URL
 * @param {string} customFilename - 自定义文件名
 */
const downloadFile = async (url, customFilename) => {
  try {
    const token = userTokenStore().token
    const response = await axios.get(
        url,
        {
          responseType: 'blob',
          headers: {
            'Authorization': token.tokenValue,
            'Login-Type': token.loginType,
            'Content-Type': 'application/json',
          },
        }
    );

    // 创建下载链接
    const blob = new Blob([response.data]);
    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.setAttribute('download', customFilename); // 使用传入的自定义文件名
    document.body.appendChild(link);
    link.click();

    // 清理
    setTimeout(() => {
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
    }, 100);

    return true;
  } catch (error) {
    console.error('文件下载失败:', error);
    ElMessage.error('文件下载失败，原因：暂无数据');
    return false;
  }
};
</script>

<template>
  <div class="container_box">
    <v-row justify="center">
      <v-col cols="11">
        <v-data-table
            :headers="headers"
            :items="tableData"
            :loading="loading"
            :items-per-page="$globalPageSize"
            :no-data-text="'没有更多数据了~'"
            hover
        >
          <template v-slot:loading>
            <v-skeleton-loader type="table-row@1"></v-skeleton-loader>
          </template>

          <template v-slot:top>
            <v-form>
              <v-container>
                <v-row justify="center">
                  <v-col cols="3">
                    <v-select
                        ref="storeListRef"
                        v-model="cacheStore.name"
                        :items="storeListArr"
                        item-title="name"
                        item-value="storeId"
                        label="门店"
                        variant="outlined"
                        :no-data-text="'没有更多数据了~'"
                        @update:modelValue="handleSelectStore"
                        :loading="storeLoading"
                        placeholder="请选择门店"
                        :menu-props="{maxHeight: '550px'}"
                        @update:menu="handleClickSelect"
                    >
                      <template v-slot:prepend-item>
                        <div class="pd_l_1 pd_r_1 pd_t_1" style="width: 300px">
                          <v-text-field
                              v-model="storeSelectKey"
                              placeholder="请输入门店名称"
                              label="门店名称"
                              variant="outlined"
                              clearable
                              append-inner-icon="mdi-magnify"
                              @click:append-inner="handleGetStore('search')"
                              @keydown.enter="handleGetStore('search')"
                              :disabled="storeLoading"
                          ></v-text-field>
                        </div>
                        <v-divider class="mb-2"></v-divider>
                      </template>
                      <template v-slot:append-item>
                        <v-divider class="mb-2"></v-divider>
                        <YTTablePagination ref="YTTablePaginationMemberRef" :pageSize="5" :total="memberTotal" @page-change="handleChangeMemberPage"></YTTablePagination>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col cols="3">
                    <v-select
                        v-model="formData.date"
                        :model-value="formData.date ? handleDateFormat(formData.date) : null"
                        label="开始日期"
                        variant="outlined"
                        placeholder="请选择开始日期"
                        :menu-props="{maxHeight: '550px'}"
                    >
                      <template v-slot:no-data style="max-height: 550px">
                        <div class="flex_center" style="position: relative">
                          <v-date-picker color="#ED5513" title="选择开始日期" :hide-header="false" locale="zh-cn" @update:modelValue="handleSelectDate" v-model="formData.date" show-adjacent-months>
                            <template #header>
                              <div class="text-h4" style="box-sizing: border-box;padding: 0 12px 12px 24px"> {{ formData.date ? handleDateFormat(formData.date) : "请选择开始日期" }}</div>
                            </template>
                          </v-date-picker>
                        </div>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col cols="3">
                    <v-select
                        v-model="formData.endDate"
                        :model-value="formData.endDate  ? handleDateFormat(formData.endDate) : null"
                        label="结束日期"
                        variant="outlined"
                        placeholder="请选择结束日期"
                        :menu-props="{maxHeight: '550px'}"
                    >
                      <template v-slot:no-data style="max-height: 550px">
                        <div class="flex_center" style="position: relative">
                          <v-date-picker :min="formData.date" color="#ED5513" title="选择结束日期" :hide-header="false" locale="zh-cn" @update:modelValue="handleSelectEndDate" v-model="formData.endDate" show-adjacent-months>
                            <template #header>
                              <div class="text-h4" style="box-sizing: border-box;padding: 0 12px 12px 24px"> {{ formData.endDate ? handleDateFormat(formData.endDate) : "请选择结束日期" }}</div>
                            </template>
                          </v-date-picker>
                        </div>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col cols="3">
                    <v-row justify="end">
                      <v-col class="flex_right" cols="6">
                        <v-btn color="success" size="large" @click="handleSearch('btnSearch')" :disabled="!$handleHasBtnPermission('any', 'adminTicketPageRedemption:view')">搜索</v-btn>
                      </v-col>
                      <v-col class="flex_right" cols="6">
                        <v-btn size="large" @click="handleReset" :disabled="!$handleHasBtnPermission('any', 'adminTicketPageRedemption:view')">重置</v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
            <div class="flex_left mg_b_2">
              <v-btn color="success" @click="handleDownload()" :disabled="!$handleHasBtnPermission('any', 'adminTicketPageRedemption:export')">下载</v-btn>
            </div>
          </template>

          <template v-slot:item.nickname=" { item } ">
            {{item.nickname ? item.nickname : "-"}}
          </template>

          <template v-slot:item.memberLevel=" { item }">
            <div>{{item.levelName}}</div>
          </template>

          <template v-slot:item.crUserName=" { item } ">
            {{item.type === 'SYSTEM' ? 'System' : item.crUserName}}
          </template>

          <template v-slot:bottom>
            <YTTablePagination ref="YTTablePaginationRef" :pageSize="$globalPageSizeHalf" :total="total" @page-change="handleChangePage"></YTTablePagination>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<style scoped>
.btn_check {
  width: 28px;
  height: 28px;
  border-radius: 36px;
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(50%, -50%);
  z-index: 100;
  background-color:#4caf50;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
